import { useState } from 'react';
import { TextField, Dialog, DialogContent, DialogTitle, Button, DialogActions, Box } from '@mui/material';
import { createNewRequirement, buildRequirementPayload } from './Config/FirebaseFunctions';
import MessageDialog from '../../../utils/MessageDialog';

// Dialog component for creating new visit requirements
const VisitsCreateDialog = ({ open, onClose, companyRef }) => {
  // State for form data with initial empty values
  const [formData, setFormData] = useState({
    nombre: '',
    documento: '',
    direccion: '',
    telefono: ''
  });

  // State for message dialog
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogMessage, setDialogMessage] = useState('');

  // Function to show message dialog with custom title and message
  const showDialog = (title, message) => {
    setDialogTitle(title);
    setDialogMessage(message);
    setDialogOpen(true);
  };

  // Handle dialog close event
  const handleClose = e => {
    e.preventDefault();
    onClose();
  };

  // Handle form input changes
  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Validate that all form fields are filled
  const validateForm = () => {
    const { nombre, documento, direccion, telefono } = formData;
    return (
      nombre.trim().length > 0 &&
      documento.trim().length > 0 &&
      direccion.trim().length > 0 &&
      telefono.trim().length > 0
    );
  };

  // Handle form submission
  const handleSubmit = async e => {
    e.preventDefault();

    // Check if form is valid before submitting
    if (validateForm()) {
      try {
        // Build payload and create new requirement in Firebase
        const payload = buildRequirementPayload(formData, companyRef);
        await createNewRequirement(payload);
        showDialog('Éxito', 'El requerimiento ha sido creado exitosamente.');
        cleanFields();
      } catch (error) {
        showDialog('Error', 'Hubo un problema al crear el requerimiento. Por favor, inténtelo de nuevo.');
      }
    } else {
      showDialog('Error de Validación', 'Por favor, complete todos los campos obligatorios.');
    }
  };

  // Reset form fields to empty values
  const cleanFields = () => {
    setFormData({
      nombre: '',
      documento: '',
      direccion: '',
      telefono: ''
    });
  };

  return (
    <>
      {/* Main dialog for creating new requirements */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Nuevo Requerimiento</DialogTitle>

        <DialogContent>
          {/* Candidate name field */}
          <TextField
            label="Nombre del candidato"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            margin="dense"
            required
          />
          
          {/* Candidate identification field */}
          <TextField
            label="Identificación del candidato"
            name="documento"
            value={formData.documento}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
          />
          
          {/* Candidate address field */}
          <TextField
            label="Dirección del candidato"
            name="direccion"
            value={formData.direccion}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
          />
          
          {/* Candidate phone field */}
          <TextField
            label="Teléfono del candidato"
            name="telefono"
            value={formData.telefono}
            onChange={handleChange}
            fullWidth
            margin="dense"
            required
          />
        </DialogContent>

        <DialogActions>
          {/* Action buttons */}
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <Button onClick={handleClose} color="primary" style={{ marginRight: '10px' }}>
              Cancelar
            </Button>
            <Button onClick={handleSubmit} type="submit" color="primary">
              Solicitar
            </Button>
          </Box>
        </DialogActions>
      </Dialog>

      {/* Message dialog for showing success/error messages */}
      <MessageDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        title={dialogTitle}
        message={dialogMessage}
      />
    </>
  );
};

export default VisitsCreateDialog;